import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { catchError, from, map, of, switchMap, take } from 'rxjs';

import { AuthInitService } from '@app/core/init/auth-init.service';
import { isDevLocalBypassMode } from '@app/core/init/utils';

import { AuthSessionService } from '@core/services/auth-session.service';

function handleExpiredSession(router: Router) {
  return of(router.createUrlTree(['/error/401'])).pipe(
    map((tree) => {
      return tree;
    })
  );
}

function ensureOr401(promise: Promise<boolean | UrlTree>, router: Router) {
  return from(promise).pipe(
    catchError(() => of(false)),
    switchMap((result) => {
      if (result === true) {
        return of(true);
      }
      if (result === false) {
        return handleExpiredSession(router);
      }
      return of(result);
    })
  );
}

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthSessionService);
  const router = inject(Router);
  const init = inject(AuthInitService);

  return auth.isAuthenticated$.pipe(
    take(1),
    switchMap((isAuthenticated) => {
      if (isAuthenticated) {
        return of(true);
      }

      // Not authenticated: com ?mode=dev em localhost redireciona ao login interno
      if (isDevLocalBypassMode()) {
        return ensureOr401(init.ensureDevLoggedIn(), router);
      }

      // Not authenticated in production: try to log in
      return ensureOr401(init.ensureProductionLoggedIn(), router);
    })
  );
};
